import { Box, Href, Section, Text } from '@factorialco/deprecated-design-system'
import {
  IntegrationsPrimoboxToggleFeatureDocument,
  IntegrationsPrimoboxToggleFeatureMutation,
} from 'generated/resources/graphql'

import Toggler from 'modules/core/components/Toggler'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  enabled: boolean
  onToggle: (value: boolean) => void
}

const ActivationRow = ({ enabled, onToggle }: Props) => {
  const [enableFeature, { loading }] = useMutation(IntegrationsPrimoboxToggleFeatureDocument, {
    extractorFn: (data: IntegrationsPrimoboxToggleFeatureMutation) =>
      data.integrationsPrimoboxMutations.toggleIntegrationsprimoboxFeature,
  })

  const {
    company: { id: companyId },
  } = useCurrentSession()

  const onChange = async () => {
    const result = await enableFeature({ variables: { companyId, enabled: !enabled } })
    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('integrations_primobox.activation_row.success_message'),
        time: 2000,
      })

      onToggle(handled?.data?.feature?.enabled || false)
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('integrations_primobox.activation_row.error_message'),
        time: 2000,
      })
    }
  }

  return (
    <Section
      title={i18n.t('integrations_primobox.activation_row.title')}
      description={i18n.t('integrations_primobox.activation_row.description')}
      illustration="common-file-text-upload"
    >
      <Box
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs016',
        }}
        gap="s8"
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        padding="s16"
      >
        <Box gap="s4">
          <Box flexDirection="row" justifyContent="spaceBetween" paddingBottom="s16">
            <Text.Normal color="grey1000" weight="medium">
              {i18n.t('integrations_primobox.activation_row.enable_title')}
            </Text.Normal>
            <Toggler active={enabled} onChange={onChange} disabled={loading} />
          </Box>
          <Text.Normal color="grey800" weight="normal" size="200">
            {i18n.tView('integrations_primobox.activation_row.enable_description', {
              tc_markup: (
                <Href
                  href={i18n.t('integrations_primobox.activation_row.enable_description_tc_link')}
                  target="_blank"
                >
                  {i18n.t('integrations_primobox.activation_row.enable_description_tc_text')}
                </Href>
              ),
              dpa_markup: (
                <Href
                  href={i18n.t('integrations_primobox.activation_row.enable_description_dpa_link')}
                  target="_blank"
                >
                  {i18n.t('integrations_primobox.activation_row.enable_description_dpa_text')}
                </Href>
              ),
            })}
          </Text.Normal>
        </Box>
      </Box>
    </Section>
  )
}

export default ActivationRow
